import { Modal } from "antd";
import React from "react";
import ErrorPage from "../Notification/Error";

function Payment({ props }) {
  const {
    isModal,
    onCancel,
    tempData,
    onSelect,
    onChange,
    loadChat,
    isErrorModal,
  } = props;
  return (
    <Modal
      title={null}
      visible={isModal}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={400}
    >
      <div>
        <p className="colors-blue text-2xl mb-3 font-bold">
          {tempData.name === "note"
            ? "Ubah Catatan"
            : tempData.name === "tgl_pemeriksaan"
            ? "Ubah Tanggal"
            : "Ubah Waktu"}
        </p>
        <p className="colors-gray text-base mb-8 w-full">
          Anda dapat mengubah{" "}
          {tempData.name === "note"
            ? "catatan"
            : tempData.name === "tgl_pemeriksaan"
            ? "tanggal"
            : "waktu"}{" "}
          dengan mengganti{" "}
          {tempData.name === "note"
            ? "catatan"
            : tempData.name === "tgl_pemeriksaan"
            ? "tanggal"
            : "waktu"}{" "}
          dibawah ini
        </p>
        {/* Input Section */}
        <div className="mb-5">
          {tempData.name === "note" && (
            <div name="catatan-form" className="mt-5">
              <p className="login-title-form mb-1 text-lg">Catatan</p>
              <textarea
                onChange={(e) => onChange(e)}
                value={tempData.value}
                name="note"
                className="form-input outline-none w-full p-3"
                placeholder="Catatan bila ada"
              />
            </div>
          )}
          {tempData.name === "tgl_pemeriksaan" && (
            <div name="tanggal-form" className="mt-5">
              <p className="login-title-form mb-1 text-lg">Pilih Tanggal</p>
              <input
                onChange={(e) => onChange(e)}
                value={tempData.value}
                name="tgl_pemeriksaan"
                type="date"
                className="form-input outline-none w-full p-3"
                placeholder="silahkan pilih tanggal"
              />

              {isErrorModal
                ? isErrorModal.length > 0
                  ? isErrorModal
                      .filter((it) => it.type === "date")
                      .map((its, idx) => (
                        <ErrorPage
                          key={idx}
                          props={{ idx, message: its.message }}
                        />
                      ))
                  : null
                : null}
            </div>
          )}
          {tempData.name === "jam_pemeriksaan" && (
            <div name="time-form" className="mt-5">
              <p className="login-title-form mb-1 text-lg">Pilih Waktu</p>
              <input
                onChange={(e) => onChange(e)}
                value={tempData.value}
                name="jam_pemeriksaan"
                type="time"
                className="form-input outline-none w-full p-3"
                placeholder="silahkan pilih waktu"
              />

              {isErrorModal
                ? isErrorModal.length > 0
                  ? isErrorModal
                      .filter((it) => it.type === "time")
                      .map((its, idx) => (
                        <ErrorPage
                          key={idx}
                          props={{ idx, message: its.message }}
                        />
                      ))
                  : null
                : null}
            </div>
          )}
        </div>
        <div>
          <button
            disabled={loadChat}
            onClick={onSelect}
            className="btn-blue w-full p-3 mt-8 focus:outline-none"
          >
            <div className="text-white lg:text-lg">
              {tempData.name === "note"
                ? "Ubah Catatan"
                : tempData.name === "tgl_pemeriksaan"
                ? "Ubah Tanggal"
                : "Ubah Waktu"}
            </div>
          </button>
          <p
            onClick={onCancel}
            className="text-center mt-5 cursor-pointer colors-gray font-semibold text-base"
          >
            Batal
          </p>
        </div>
      </div>
    </Modal>
  );
}

export default Payment;
